import { useController } from "react-hook-form";

import { groupByKeys } from "utils";

const withType = (type) => {
  return (props) => {
    return { ...props, type };
  };
};

export function useStreamTagController({
  id,
  parameters,
  operand,
  streams = [],
  tags = [],
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: id,
    defaultValue: {
      operand: operand || parameters[0].operands[0],
      streams: streams.map(withType("stream")),
      tags: tags.map(withType("tag")),
    },
    rules: {
      validate: ({ streams: s = [], tags: t = [] }) => {
        return Boolean(s.length || t.length);
      },
      required: { value: true, message: "Please select streams or tags" },
    },
  });

  return {
    operandProps: {
      value: field.value.operand,
      options: parameters[0].operands,
      onChange: (_, v) => {
        field.onChange({ ...field.value, operand: v });
      },
    },
    streamTagProps: {
      value: [...field.value.streams, ...field.value.tags],
      onChange: (_, { value }) => {
        const g = groupByKeys(value, ["stream", "tag"]);
        field.onChange({
          ...field.value,
          streams: g.streams,
          tags: g.tags,
        });
      },
      onBlur: field.onBlur,
      error: Boolean(error),
    },
  };
}

export default useStreamTagController;
